import React, { ReactElement } from 'react';
import Styled from './Header.styled';
import { ComponentProps } from './Header.types';

const Header = ({ title, mode = 'default', ...props }: ComponentProps): ReactElement<ComponentProps> => {
  return (
    <Styled mode={mode} pb={6} pt={4} mx={4} {...props}>
      {title}
    </Styled>
  );
};

export default Header;
